import { useAuth } from "@crm/access/hooks/use-auth";
import { useMemo } from "react";
import {
  getMainNavigation,
  getManagementNavigation,
  getNotificationNavigation,
  isNavigationVisible,
} from "../config";

/**
 * 使用主导航配置 Hook
 */
export function useMainNavigation() {
  const { user, permissions } = useAuth();

  return useMemo(() => {
    const allNavItems = getMainNavigation();
    return allNavItems.filter((nav) => isNavigationVisible(nav, user?.role, permissions));
  }, [user?.role, permissions]);
}

/**
 * 使用管理菜单配置 Hook
 */
export function useManagementNavigation() {
  const { user, permissions } = useAuth();

  return useMemo(() => {
    const allNavItems = getManagementNavigation();
    return allNavItems.filter((nav) => isNavigationVisible(nav, user?.role, permissions));
  }, [user?.role, permissions]);
}

/**
 * 使用通知导航配置 Hook
 */
export function useNotificationNavigation() {
  const { user, permissions } = useAuth();

  return useMemo(() => {
    const allNavItems = getNotificationNavigation();
    return allNavItems.filter((nav) => isNavigationVisible(nav, user?.role, permissions));
  }, [user?.role, permissions]);
}

/**
 * 检查管理菜单是否可访问
 */
export function useHasManagementAccess(): boolean {
  const managementNav = useManagementNavigation();
  return managementNav.length > 0;
}
